import { html } from '@design.estate/dees-element';
import { demoPage, demoOutput, showDemoResult } from '../../../demos/templates.js';

const logEvent = (event: CustomEvent) => {
  showDemoResult(event.currentTarget as Element, { event: event.type, ...event.detail });
};

export const demoFunc = () => demoPage('Composer', 'Write, attach files, choose a model, and steer a running task.', html`
  <div
    class="composerDemo dees-demo-stack"
    @harness-send=${logEvent}
    @harness-steer=${logEvent}
    @harness-steer-input=${logEvent}
    @harness-abort=${logEvent}
    @harness-input=${logEvent}
    @harness-attachments-change=${logEvent}
    @harness-attachment-error=${logEvent}
    @harness-account-change=${logEvent}
    @harness-model-change=${logEvent}
    @harness-mode-change=${logEvent}
  >
    <div class="dees-demo-label">Account, model and mode</div>
    <dees-harness-composer
      contextDescription="Replying to Deploy assistant"
      account="account-1"
      model="gpt-5.5"
      reasoningEffort="high"
      mode="Planning"
      .modeOptions=${['Planning', 'Building']}
      .accountOptions=${[
        { label: 'Personal · alex@example.com', value: 'account-1' },
        { label: 'Team · alex@example.com', value: 'account-2' },
      ]}
      .modelOptions=${['gpt-5.5', 'gpt-5', 'o4-mini']}
      .effortOptions=${['xhigh', 'high', 'medium', 'low']}
    >
      <div slot="context" style="padding:8px 12px 0;font-size:11px;line-height:16px;color:var(--dees-color-text-secondary)">
        Replying to <strong>Deploy assistant</strong>
      </div>
    </dees-harness-composer>
    <div class="dees-demo-label">Queue a follow-up while the agent works</div>
    <dees-harness-composer busy value="Refactor the sitemap job…"></dees-harness-composer>
    <div class="dees-demo-label">Steer the task with queued messages</div>
    <dees-harness-composer busy queuedCount="2"></dees-harness-composer>
    <div class="dees-demo-label">Waiting for a connection</div>
    <dees-harness-composer disabled placeholder="Connect to a project to chat."></dees-harness-composer>
    <div class="dees-demo-label">Text-only conversation</div>
    <dees-harness-composer .attachmentsEnabled=${false} .showModelControls=${false}
      value="Summarize the outstanding invoices."></dees-harness-composer>
    <div class="dees-demo-label">Files ready to send</div>
    <dees-harness-composer
      .showModelControls=${false}
      .attachments=${[
        { id: 'a1', name: 'build.log', mediaType: 'text/plain', size: 5120, kind: 'text' as const },
        { id: 'a2', name: 'screenshot.png', mediaType: 'image/png', size: 44_000, kind: 'image' as const },
      ]}
    ></dees-harness-composer>
    ${demoOutput()}
  </div>
`);
